export function getAuthErrorMessage(status: unknown, serverMessage?: string): string {
  if (status === 401) return "Email ou mot de passe incorrect.";
  if (status === 403) return "Vous devez réinitialiser votre mot de passe. Utilisez la récupération de compte.";
  if (status === 429) return serverMessage ?? "Trop de tentatives. Réessayez plus tard.";
  if (status === 409) return "Impossible de créer le compte. Vérifiez vos informations.";
  if (status === 400) return "Ce mot de passe est trop courant. Choisissez un mot de passe plus sécurisé.";
  return "Une erreur est survenue. Réessayez.";
}
